<template>
  <div class="helpcenter-article-view__wrapper">
    <NavBar class="helpcenter-article-view__nav">
      <template #left>
        <span>
          <BackButton />
        </span>
      </template>

      <template #center>
        <span>Artigo</span>
      </template>
    </NavBar>

    <div
      class="helpcenter-article-view__content"
      :class="{
        'helpcenter-article-view__content--impersonate': isImpersonate
      }"
    >
      <SkeletonLoader
        v-if="isLoading"
        class="helpcenter-article-view__content__loader"
        data-testid="loader"
      >
        <div v-for="index in 5" :key="index" class="row-loader" />
      </SkeletonLoader>

      <div v-else>
        <Heading :level="2">{{ article.title }}</Heading>

        <div
          class="helpcenter-article-view__content__body"
          v-html="article.body"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader, Heading } from '@warrenbrasil/nebraska-web';
import { NavBar } from '@/modules/common/components/__deprecated__/NavBar';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import {
  getArticle,
  IHelpCenterArticle
} from '@/modules/help-center/services/help-center';
import { isImpersonate } from '@/modules/common/services/partner';

@Component({
  components: {
    SkeletonLoader,
    BackButton,
    Heading,
    NavBar
  }
})
export default class HelpCenterView extends Vue {
  isLoading = true;
  isImpersonate = false;
  article: IHelpCenterArticle | null = null;

  private async mounted() {
    this.isImpersonate = isImpersonate();
    const { article } = await getArticle(this.$route.params.articleId);
    this.article = article;
    this.isLoading = false;
  }
}
</script>

<style lang="less" scoped>
@height-navbar: 64px;

.helpcenter-article-view__wrapper {
  .helpcenter-article-view__nav {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 20;
    border-bottom: 1px solid @divider-primary;
    background: @background-secondary !important;
    * > {
      color: @text-primary !important;
    }
  }
  .helpcenter-article-view__content {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    min-height: calc(100vh - @height-navbar);
    margin: 0px auto;
    padding: @spacing-xxl @size-spacing-x500 0px;

    &.helpcenter-article-view__content--impersonate {
      padding: calc(@spacing-xxl + @size-spacing-x300) @size-spacing-x400 0px;
    }

    .helpcenter-article-view__content__body /deep/ p {
      text-align: justify;
      line-height: 1.6;
      margin: 1em 0;

      img {
        max-width: 100%;
      }
    }
  }
}

.helpcenter-article-view__content__loader {
  padding-top: @size-spacing-x800;
  .row-loader {
    height: 30px;
    margin: @size-spacing-x500 0;
    border-radius: 10px;
  }
}
</style>
